exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.price-sheet-multipliers {\n    margin-top: 2rem;\n}\n.select-account {\n    margin-bottom: 2rem;\n}\n.price-sheet-table {\n    margin-top: 1rem;\n}\n.loading {\n    text-align: center;\n    padding: 2rem;\n}\n.error {\n    color: red;\n    margin: 1rem 0;\n}\n", ""]);

// exports
